export const getNavbarHeight = state => state.navbarHeight.height;
